import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Sparkles, Check, ChevronRight } from 'lucide-react';
export function Slide01Title() {
  return <div className="w-full h-full flex" data-id="element-16">
      {/* Left Content */}
      <div className="w-1/2 h-full flex flex-col justify-center px-[clamp(4rem,8vw,10rem)] relative z-10" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mb-12 w-16 h-16 bg-[var(--surface-alt)] rounded-2xl flex items-center justify-center text-[var(--fg)] shadow-sm" data-id="element-18">
          <Leaf size={32} strokeWidth={1.5} data-id="element-19" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="font-display text-[clamp(3rem,5vw,5.5rem)] leading-[1.05] tracking-tight mb-6" data-id="element-20">
          Project <span className="text-[var(--accent)] italic" data-id="element-21">Autopilot</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-[clamp(1.25rem,1.5vw,1.75rem)] text-[var(--fg-muted)] max-w-xl mb-16 leading-relaxed" data-id="element-22">
          Discovery Readout: AI-Driven Meal Planning
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="flex items-center gap-4 text-sm font-semibold tracking-widest uppercase text-[var(--fg-muted)]" data-id="element-23">
          <span data-id="element-24">Product Team</span>
          <span className="w-1.5 h-1.5 rounded-full bg-[var(--accent)]" data-id="element-25" />
          <span data-id="element-26">Q3 Planning</span>
        </motion.div>
      </div>

      {/* Right Mockup */}
      <motion.div initial={{
      opacity: 0,
      scale: 1.05
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="w-1/2 h-full relative flex items-center justify-center bg-[var(--surface)]/50 overflow-hidden" data-id="element-27">
        {/* Background decorative glow */}
        <div className="absolute w-[150%] h-[150%] bg-gradient-to-tr from-[var(--surface-alt)] to-[var(--bg)] rounded-full blur-3xl opacity-60 -z-10" data-id="element-28" />

        <motion.div animate={{
        y: [0, -15, 0]
      }} transition={{
        repeat: Infinity,
        duration: 6,
        ease: 'easeInOut'
      }} className="relative w-[clamp(280px,22vw,340px)] h-[min(680px,82vh)] bg-[var(--bg)] rounded-[3rem] border-[14px] border-white shadow-2xl overflow-hidden flex flex-col rotate-[-4deg]" data-id="element-29">
          {/* Dynamic Island */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-36 h-7 bg-white rounded-b-3xl z-20" data-id="element-30" />

          <div className="p-6 pt-14 flex-1 flex flex-col gap-5 relative z-10" data-id="element-31">
            <div className="flex justify-between items-center" data-id="element-32">
              <div data-id="element-33">
                <div className="text-[10px] text-[var(--fg-muted)] font-bold uppercase tracking-widest mb-1" data-id="element-34">
                  This Week
                </div>
                <div className="font-display text-3xl text-[var(--fg)] leading-none" data-id="element-35">
                  Autopilot
                </div>
              </div>
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-[var(--accent)] shadow-sm" data-id="element-36">
                <Sparkles size={20} data-id="element-37" />
              </div>
            </div>

            <div className="bg-white rounded-3xl p-3 shadow-sm border border-[var(--surface-alt)]/50" data-id="element-38">
              <img src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?q=80&w=800&auto=format&fit=crop" alt="Fresh healthy meal" className="w-full h-40 object-cover rounded-2xl mb-4" data-id="element-39" />
              <div className="px-2" data-id="element-40">
                <div className="font-semibold text-[var(--fg)] mb-1 text-lg" data-id="element-41">
                  High-Protein Week
                </div>
                <div className="text-xs text-[var(--fg-muted)] mb-4 font-medium" data-id="element-42">
                  7 meals • 120g protein/day
                </div>
                <button className="w-full py-3.5 bg-[var(--fg)] text-[var(--bg)] rounded-xl font-semibold text-sm flex justify-center items-center gap-2 shadow-md shadow-[var(--fg)]/20" data-id="element-43">
                  <Check size={18} data-id="element-44" /> Approve Plan
                </button>
              </div>
            </div>

            <div className="space-y-3" data-id="element-45">
              {[{
              day: 'Mon',
              name: 'Citrus Salmon'
            }, {
              day: 'Tue',
              name: 'Quinoa Bowl'
            }].map((meal, i) => <div key={i} className="h-16 bg-white rounded-2xl border border-[var(--surface-alt)]/50 flex items-center p-2 gap-3 shadow-sm" data-id="element-46">
                  <div className="w-12 h-12 bg-[var(--surface-alt)]/30 rounded-xl flex items-center justify-center text-[var(--accent)] font-bold text-xs uppercase" data-id="element-47">
                    {meal.day}
                  </div>
                  <div className="flex-1" data-id="element-48">
                    <div className="h-2.5 w-2/3 bg-[var(--fg)]/10 rounded-full mb-2" data-id="element-49" />
                    <div className="h-2 w-1/3 bg-[var(--fg)]/5 rounded-full" data-id="element-50" />
                  </div>
                </div>)}
            </div>
          </div>

          {/* Bottom Nav Mock */}
          <div className="absolute bottom-0 w-full h-24 bg-white border-t border-[var(--surface-alt)]/50 flex items-start pt-4 justify-around px-6 z-20" data-id="element-51">
            <div className="w-12 h-12 rounded-full bg-[var(--fg)]/5 flex items-center justify-center" data-id="element-52">
              <Leaf size={24} className="text-[var(--fg)]" data-id="element-53" />
            </div>
            <div className="w-12 h-12 rounded-full flex items-center justify-center" data-id="element-54">
              <Sparkles size={24} className="text-[var(--fg-muted)]/40" data-id="element-55" />
            </div>
            <div className="w-12 h-12 rounded-full flex items-center justify-center" data-id="element-56">
              <ChevronRight size={24} className="text-[var(--fg-muted)]/40" data-id="element-57" />
            </div>
          </div>
        </motion.div>
      </motion.div>
    </div>;
}